import React from "react";
import { useLang } from "../LanguageContext";

export const LanguageToggle = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  const base = dark ? "text-white/70" : "text-[#002B7F]";
  const active = dark
    ? "bg-[#F37021] text-white"
    : "bg-[#002B7F] text-white";
  return (
    <div
      className="inline-flex items-center rounded-full overflow-hidden border"
      style={{
        borderColor: dark ? "rgba(255,255,255,0.2)" : "rgba(0,43,127,0.2)",
      }}
      data-testid="language-toggle"
    >
      {["ro", "en"].map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          className={`px-2.5 sm:px-3 py-1.5 text-[12px] font-bold tracking-[0.12em] transition-all whitespace-nowrap ${
            lang === code ? active : base
          }`}
          aria-label={`Switch to ${code.toUpperCase()}`}
          data-testid={`lang-btn-${code}`}
        >
          <span className="hidden sm:inline">{code === "ro" ? "🇷🇴 " : "🇬🇧 "}</span>{code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
